import { defineStore } from "pinia"
import { ref } from "vue"

/**
 * 操作禁止ストア
 * 画面共有中などアプリ操作を受け付けたくない状態を管理する
 *
 * NOTE: 現在は lock/unlock の呼び出し元が1箇所（蔵電通話の画面共有）のみ。
 * 複数機能からロックを取る場合は、ラベル付きロック（Set<string>）や
 * カウンター方式に変更し、他機能のロックを誤って解除しないようにすること。
 */
export const useOperationLockStore = defineStore('operationLock', () => {
  const isLocked = ref(false)

  const lock = () => {
    isLocked.value = true
  }

  const unlock = () => {
    isLocked.value = false
  }

  return {
    isLocked,
    lock,
    unlock,
  }
})
